import React from 'react';
import {UncontrolledTooltip} from 'reactstrap';
import {Link} from '..';

interface Props {
  label: string;
  tooltip: string;
  route?: string;
  active?: boolean;
}

export class TooltipBreadcrumb extends React.Component<Props> {
  readonly labelRef = React.createRef<any>();

  render() {
    const props = this.props;
    const classname = props.active === true
      ? 'breadcrumb-item active'
      : 'breadcrumb-item';

    return (
      <div className={classname}>
        {this.renderLabelled()}
        <UncontrolledTooltip target={this.labelRef}
                             placement="bottom"> {props.tooltip} </UncontrolledTooltip>
      </div>
    );
  }

  private renderLabelled(): React.ReactNode {
    const props = this.props;
    if (props.route === undefined)
      return (<span ref={this.labelRef}> {props.label} </span>);
    return (<Link innerRef={this.labelRef} to={props.route}> {props.label} </Link>);
  }
}
